<template>
    <HomeStaff v-if="userIsStaff()" />
    <component :is="customerSpecificHomeVeranstalter" v-else />
</template>

<script lang="ts">
import Vue from 'vue';
import { userIsStaff } from '@/helpers/auth';

import HomeStaff from '@/components/dashboard/HomeStaff.vue';
import HomeVeranstalter from '@/components/dashboard/HomeVeranstalter.vue';
import HomeVeranstalterSaiten from '@/customer_specific/saiten/components/dashboard/HomeVeranstalterSaiten.vue';
import { customer } from '@/helpers/globals';

export default Vue.extend({
    name: 'HomeView',
    components: {
        HomeStaff,
    },
    computed: {
        customerSpecificHomeVeranstalter() {
            switch (customer()) {
                case 'saiten':
                    return HomeVeranstalterSaiten;
                case 'tgk':
                default:
                    return HomeVeranstalter;
            }
        },
    },
    methods: {
        userIsStaff,
    },
});
</script>
